import React from 'react'
import styled from 'styled-components'

import Input from 'components/lib/DesignSystem/Input'
import Button from 'components/lib/DesignSystem/Button'

class TeamsFourthStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  handleEditUrl = (e) => this.props.updateWebhookUrl(e.target.value)

  handleCompleteIntegration = () => this.props.updateNotifications()

  render() {
    const { className, error, webhookUrl, permissions, isStaticSalesDemo } = this.props

    return (
      <div className={className}>
        <img
          src="/static/webapp/images/settings/teams-step-4.png"
          style={{ width: '563px', height: '370px' }}
        />
        <div className="actions-container">
          <div>
            <div className="number-indication">1</div>
            <span className="text-indication">
              Copy the workflow's URL and paste it below. Note that you can always copy it from the
              Home tab in the
              <b> Workflows </b>
              Teams page.
            </span>
            <div className="url-container">
              <Input
                id="Settings_NotificationsTeams_FourthStep_URL_input"
                placeholder="Paste URL"
                value={webhookUrl}
                onChange={this.handleEditUrl}
              />
              {error && (
                <div className="error-container mt">
                  <img src="/static/webapp/images/settings/slack-error-icon.svg" />
                  <span className="dib-vac">{error?.detail}</span>
                </div>
              )}
            </div>
            <div className="mt">
              <div className="number-indication">2</div>
              <span className="text-indication">Click on “Done”</span>
            </div>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="teams-backButton"
          />
          {/* TODO:Change the includes text after 3 months to webhook.office.com/webhook 14/01/2021 */}
          <Button
            text="Complete Integration"
            disabled={
              !webhookUrl ||
              (!webhookUrl.includes('.office.com/webhook') &&
                !webhookUrl.includes('.logic.azure.com')) ||
              !permissions.admin ||
              isStaticSalesDemo
            }
            onClick={this.handleCompleteIntegration}
            className="sml"
            id="teams-completeIntegrationButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(TeamsFourthStep)`
  .url-container {
    margin: 15px 25px;
    input {
      width: 290px;
      border-bottom: ${(props) => props.error && '1px solid red'};
    }
  }
  .buttons-container {
    margin-top: ${(props) => (props.error ? '30px' : '63px')};
  }
`
